import {
  DATA_CONNECTOR_XANO_SCHEMA_BEGIN,
  DATA_CONNECTOR_XANO_SCHEMA_SUCCESS,
  DATA_CONNECTOR_XANO_SCHEMA_FAILURE,
  DATA_CONNECTOR_XANO_SCHEMA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function xanoSchema(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_XANO_SCHEMA_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/table-schema`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_SCHEMA_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_SCHEMA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissXanoSchemaError() {
  return {
    type: DATA_CONNECTOR_XANO_SCHEMA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_XANO_SCHEMA_BEGIN:
      return {
        ...state,
        xanoSchemaPending: true,
        xanoSchemaError: null,
      };

    case DATA_CONNECTOR_XANO_SCHEMA_SUCCESS:

      return {
        ...state,
        xanoSchemaPending: false,
        xanoSchemaError: null,
        getXanoSchemaData: action.data
      };

    case DATA_CONNECTOR_XANO_SCHEMA_FAILURE:

      return {
        ...state,
        xanoSchemaPending: false,
        xanoSchemaError: action.data.error,
      };

    case DATA_CONNECTOR_XANO_SCHEMA_DISMISS_ERROR:

      return {
        ...state,
        xanoSchemaError: null,
      };

    default:
      return state;
  }
}
